import React from 'react';
import { Select, Button } from 'antd';

import './Footer.css';

// import { documentOptions } from '../../../containers/documentsCard/data';

const Option = Select.Option;

const DocsCardFooter = ({ disabled }) => {
  return (
    <div className="footerActions">
      <div className="selectsGroup">
        <div>
          <Select
            disabled={!disabled.length}
            placeholder="Выберите действие"
            getPopupContainer={trigger => trigger.parentNode}
          >
            <Option value="download">Скачать PDF</Option>
            <Option value="print">Распечатать PDF</Option>
          </Select>
        </div>
      </div>
      <div>
        <Button
          disabled={!disabled.length}
          className="apllyButton"
          type="primary"
        >
          Применить
        </Button>
      </div>
    </div>
  );
};

export default DocsCardFooter;
